<template>
    <div class="content">
        <section>
            <div class="content-box">
                <HeaderBg :title="'Claim'" :sub_title="'Claim'" :desc="''" />

               
                <div style="padding: 50px 10px; text-align: left;">
    <p class="text-dark">
        The Claims Office is open for in-person claims. Hours: 8:30 AM - 4:30 PM, Monday - Friday
    </p>

    <p class="text-dark">
        Sign Your Ticket
        By law, the original winning ticket is the only
        valid receipt for prize claims. A Lottery ticket is a bearer instrument, which means the person who possesses it is the owner. Your signature indicates that you are the owner.
    </p>
</div>


            </div>
        </section>
    </div>
</template>

<script>
import HeaderBg from './components/HeaderBg.vue';

export default {
    name: 'ClaimPage',
    components: {
        HeaderBg,
    }
}
</script>

<style scoped></style>
